import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from "react-router-dom";
import { Alert, Button, Form, FormGroup, Input, Label } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as Sites from '../store/Sites';
import * as StudySites from '../store/StudySites';
import * as utility from '../data/Utility';

class CreateSiteInternal extends React.Component {
    constructor(props) {
        super(props);

        const create = utility.propCheck(props.create, true);
        const editing = utility.propCheck(props.editing, true);
        const linkReturn = utility.propCheck(props.linkReturn, false);
        const siteId = utility.propCheck(props.siteId, "");
        const studies = utility.propCheck(props.studies, null);
        const dynaIds = utility.propCheck(props.dynaIds, null);

        this.state = {
            create: create,
            editing: editing,
            error: false,
            linkReturn: linkReturn,
            siteId: siteId,
            dynaIds: dynaIds,
            studies: studies
        };

        this.handleCancel = this.handleCancel.bind(this);
        this.handleCode = this.handleCode.bind(this);
        this.handleName = this.handleName.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.initialize = this.initialize.bind(this);
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        this.initialize();
    }

    handleCancel() {
        if (this.state.create) {
            this.props.history.push(paths.home);
        }
        else {
            this.initialize();
            if (this.state.editing) {
                this.setState({
                    editing: false
                });
            }
        }
    }

    handleCode(e) {
        const site = this.props.sitesState.site;
        site.code = e.target.value;
        this.props.sitesDispatch.set(site);
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.handleClick();
        }
    }

    handleName(e) {
        const site = this.props.sitesState.site;
        site.name = e.target.value;
        this.props.sitesDispatch.set(site);
    }

    handleSave() {
        const site = this.props.sitesState.site;
        if (site.name === "") {
            this.setState({
                error: true
            });
        }
        else {
            this.setState({
                error: false
            });

            const studies = this.state.studies;
            const dynaIds = this.state.dynaIds;
            if (this.state.create) {
                this.props.sitesDispatch.create(studies,dynaIds);
                this.props.history.push(paths.home);
            }
            else {
                (async () => {
                    await this.props.sitesDispatch.update(studies,dynaIds);
                })().then(() => {
                    this.props.history.push(paths.manageSites);
                });
            }
        }
    }

    initialize() {
        if (this.state.linkReturn) {
            this.setState({
                linkReturn: false
            });
        }
        else {
            if (this.state.create) {
                const site = JSON.parse(JSON.stringify(Sites.emptySite));
                this.props.sitesDispatch.set(site);
            }
            else {
                const siteId = this.state.siteId;
                this.props.sitesDispatch.get(siteId);
                (async () => {
                    await this.props.studySitesDispatch.getAllBySite(siteId);
                })().then(() => {
                    const studySites = this.props.studySitesState.all;
                    if (studySites != null &&
                        studySites.forEach != null) {
                        var studyList = [];
                        studySites.forEach(studySite => {
                            studyList.push(studySite.study);
                        });
                        this.setState({
                            studies: studyList
                        });
                    }
                });
            }
        }
    }

    render() {
        if (!Accounts.authenticatedAdministrator(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        const cancel = "Cancel";
        var code = "";
        const create = this.state.create;
        var displayEditLink = false;
        const editing = this.state.editing;
        const linkTitle = "Link";
        var name = "";
        const optional = " - Optional";
        const save = "Save";
        const site = this.props.sitesState.site;
        const dynaIds = this.state.dynaIds;
        const studies = this.state.studies;
        const studiesLabel = "Studies";
        var studyNames = "";
        var title = "Create Site";

        if (!create) {
            if (editing) {
                title = "Edit Site";
            }
            else {
                displayEditLink = true;
                title = "Site";
            }
        }

        if (site != null) {
            if (site.code != null) {
                code = site.code;
            }
            if (site.name != null) {
                name = site.name;
            }
        }

        if (studies != null) {
            studyNames = utility.getNamesFromArray(studies);
        }
        const displayStudies = studyNames !== "";

        return (
            <Form>
                <h1>{title} {displayEditLink && <Button className="button-link" onClick={() => this.setState({ editing: true })}>(Edit)</Button>}</h1>
                {this.state.error && <Alert color="warning">Missing or incorrect fields.</Alert>}
                <FormGroup>
                    <Label for="nameInput">Name</Label>
                    <Input className="input" disabled={!editing} id="nameInput" onChange={this.handleName} onKeyDown={this.handleKeyDown} type="text" value={name} />
                </FormGroup>
                <FormGroup>
                    <Label for="codeInput">Code<i><small>{optional}</small></i></Label>
                    <Input className="input" disabled={!editing} id="codeInput" onChange={this.handleCode} onKeyDown={this.handleKeyDown} type="text" value={code} />
                </FormGroup>
                <div>
                    <FormGroup />
                    <Label for="studiesInput">{studiesLabel}<i><small>{optional}</small></i></Label>
                    {displayStudies ? <Input className="input" disabled id="studiesInput" title={studiesLabel} value={studyNames} /> : <br />}
                    <Button className="button small-gap" disabled={!editing} tag={Link} title={linkTitle} to={{ pathname: paths.linkStudies, state: { createSite: create, siteId: this.state.siteId, siteName: name, dynaIds: dynaIds, studies: studies } }}>{linkTitle}</Button>
                </div>
                {editing && (
                    <div className="button-gap">
                        <Button className="button" onClick={this.handleSave} title={save}>{save}</Button>{' '}
                        <Button className="button" onClick={this.handleCancel} title={cancel}>{cancel}</Button>
                    </div>
                )}
            </Form>
        );
    }
}

const CreateSiteConnect = withRouter(connect(
    state => ({
        accountsState: state.accounts,
        sitesState: state.sites,
        studySitesState: state.studySites
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        sitesDispatch: bindActionCreators(Sites.actionCreators, dispatch),
        studySitesDispatch: bindActionCreators(StudySites.actionCreators, dispatch)
    })
)(CreateSiteInternal));

export default class CreateSite extends React.Component {
    render() {
        var create = true;
        var editing = true;
        var linkReturn = false;
        var siteId = "";
        var studies = null;
        var dynaIds = null;

        const propsState = this.props.location.state;
        if (propsState != null) {
            create = utility.propCheck(propsState.create, create);
            editing = utility.propCheck(propsState.editing, editing);
            linkReturn = utility.propCheck(propsState.linkReturn, linkReturn);
            siteId = utility.propCheck(propsState.siteId, siteId);
            studies = utility.propCheck(propsState.studies, studies);
            dynaIds = utility.propCheck(propsState.dynaIds, dynaIds);
        }

        return (
            <ErrorBoundary>
                <CreateSiteConnect create={create} editing={editing} linkReturn={linkReturn} siteId={siteId} dynaIds={dynaIds} studies={studies} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateSite.js